module.exports = "<div class=\"user-container d-flex\">\n  <button class=\"username d-flex flex-column align-items-end\" *ngIf=\"user\" (click)=\"goToUserSettings()\">\n    <span>{{user.name}}</span>\n    <span>{{user.userAccountTypeDefault.agent.brandName}}</span>\n  </button>\n  <div class=\"photo\" [ngStyle]=\"{'background-image': 'url(' + userPhoto + ')'}\" *ngIf=\"user && userPhoto\"></div>\n  <div class=\"icon\" *ngIf=\"user && !userPhoto\"><i class=\"fas fa-user-circle fa-3x\"></i></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/user/user.component.html
// module id = ./src/app/header/user/user.component.html
// module chunks = main